import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { openWindow, isLinkExternal } from '@famly/vet_ts-utils_url';
import PlatformHelper from 'web-app/helpers/platform-helper';
import { Base } from 'web-app/react/components/layout/layout';
import { addHover } from 'web-app/styleguide/utils';
import { useExternalLinkWarningDialog } from './use-external-link-warning-dialog';
const openLinkInWindow = (href) => {
    openWindow(href, '_system', 'location=no');
};
const _blank = '_blank';
const noopener = 'noopener noreferrer';
const StyledLink = styled(({ ...rest }) => _jsx(Base, { as: "a", ...rest })) `
    color: ${props => props.theme.analogue2};

    ${(props) => props.inheritColor
    ? css `
                  color: inherit;
              `
    : ''}

    /* Introduced to override 'pointer-events: none' in checkbox/radiobutton label */
    pointer-events: auto;

    ${(props) => props.wordBreak
    ? css `
                  word-break: ${props.wordBreak};
              `
    : ''}

    ${props => props.underline
    ? addHover(css `
                  &:hover {
                      text-decoration: underline;
                  }
              `)
    : ''}
`;
const Link = (props) => {
    const { isFileLink, autoAdjustHref, ...attributes } = props;
    const showExternalLinkWarningDialog = useExternalLinkWarningDialog();
    let href = props.href;
    let target = props.target;
    let rel = props.rel;
    if (autoAdjustHref) {
        // URLs beginning with /api are served from the api and should open in a new window (PDFs and similar)
        const isExternal = isLinkExternal(href);
        if (href && !href.startsWith('#')) {
            if (isExternal && !target) {
                target = _blank;
            }
            else if (!isExternal) {
                href = `#${href}`;
            }
        }
    }
    const targetIsBlank = target === _blank;
    if (!rel && targetIsBlank) {
        rel = noopener;
    }
    const isFileLinkAndAndroid = isFileLink && PlatformHelper.isAndroid();
    if ((PlatformHelper.isTouch() && !targetIsBlank) || PlatformHelper.isMobileApp() || isFileLinkAndAndroid) {
        attributes.onClick = async (e) => {
            if (props.onClick) {
                const clickValue = await props.onClick(e);
                if (clickValue === false) {
                    return;
                }
            }
            if (props.showExternalLinkWarning && href && isLinkExternal(href)) {
                const shouldNavigate = await showExternalLinkWarningDialog(href);
                if (!shouldNavigate) {
                    return;
                }
            }
            if (isFileLinkAndAndroid) {
                e.preventDefault();
                if (targetIsBlank) {
                    openLinkInWindow(href);
                }
                else if (href) {
                    window.location.hash = href;
                }
            }
            else if (targetIsBlank && href) {
                e.preventDefault();
                openLinkInWindow(href);
            }
            else if (href) {
                window.location.hash = href;
            }
        };
    }
    if (props.showExternalLinkWarning && href && isLinkExternal(href)) {
        attributes.onClick = async (e) => {
            if (props.onClick) {
                const clickValue = await props.onClick(e);
                if (clickValue === false) {
                    return;
                }
            }
            e.preventDefault();
            const shouldNavigate = await showExternalLinkWarningDialog(href);
            if (shouldNavigate) {
                window.open(href, target, rel);
            }
        };
    }
    return (_jsx(StyledLink, { ...attributes, href: href, target: target, rel: rel, children: props.children }));
};
export default Link;
export const BlockLink = styled(Link) `
    display: block;
`;
